module.exports = __webpack_public_path__ + "img/vallendeman_plateau_600x600px.4657aac5.png";